<template>
  <div class="customer-container default-table">
    <div class="d-flex-row justify-content-between">
      <div style="line-height: 50px">
        <h2>重点客户(我：{{ user.name || '' }})</h2>
      </div>
      <div style="line-height: 50px">
        <i class="el-icon-info" style="color: #fe346e"></i>
        数据范围：个人（即我的销售额、关联客户、关联订单）
      </div>
    </div>
    <div class="head">
      <el-date-picker
          v-model="queryParams.year"
          value-format="yyyy"
          :clearable="false"
          format="yyyy年"
          size="mini"
          type="year"
          placeholder="选择年份" @change="handleSearch"/>
      <el-input @change="handleSearch" clearable style="width: 300px;margin:0 10px" v-model="queryParams.title"
                placeholder="模糊查询重点客户名称" size="mini"/>
      <el-button type="primary" size="mini" @click="handleSearch" :loading="loading" :disabled="loading"
                 v-if="userAuth.key_customer_sale_list">查询
      </el-button>
      <!--      <el-button type="primary" size="mini" @click="handleAppend" v-if="userAuth.key_customer_sale_add">添加重点客户-->
      <!--      </el-button>-->

      <span class="tip-time" v-if="userAuth.key_customer_sale_sync">
              <span v-if="updateDate">更新时间：{{ updateDate }} </span>
              <span v-else></span>
              <i style="display: inline-block;cursor: pointer;line-height: 50px" @click="handleRefresh('year')"
                 title="数据更新" class="el-icon-refresh"></i>
            </span>
    </div>
    <MlPageTable
        :loading="loading"
        :all-columns='userColumns'
        :table-name='tableName'
        :data-list='tableData'
        :limit.sync='configPage.page_size'
        :page.sync='configPage.current_page'
        :total.sync='configPage.total'
        :show-index='true'
        height='650px'
        highlight-current-row
        @getList='getTableData'
        ref="elAdIncomeTable"
        stripe
        :border="true" v-if="userAuth.key_customer_sale_list">
      <!--      <el-table-column slot="first-column" label="操作" header-align="center" width="130" align="center">-->
      <!--        <template slot-scope="{row}">-->
      <!--          <el-link type="primary" size="mini" icon="el-icon-edit"-->
      <!--                   :disabled="loading" @click="handleUpdate(row)" v-if="userAuth.key_customer_sale_edit">修改-->
      <!--          </el-link>-->
      <!--          &nbsp;-->
      <!--          &nbsp;-->
      <!--          <el-link type="danger" size="mini" icon="el-icon-delete"-->
      <!--                   :disabled="loading" @click="handleDelete(row)" v-if="userAuth.key_customer_sale_delete">删除-->
      <!--          </el-link>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
<!--      <template slot="title">-->
<!--        <el-table-column align="left" header-align="center" prop="title" label="重点客户" width="260" show-overflow-tooltip>-->
<!--          <template slot-scope="{row,column}">-->
<!--           <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">-->
<!--             <el-link type="primary" style="font-size: 12px" @click="toDetail(row)" title="仅看我权限范围内的客户">-->
<!--               <el-tag size="small" v-if="row.scope_all==='Y'" effect="plain" plain type="warning"-->
<!--                       style="margin-right: 5px;" title="重点客户关联的全部客户">全-->
<!--               </el-tag>-->
<!--               {{ row[column.property] || '' }}-->
<!--             </el-link>-->
<!--             <el-link @click="showRelDialog(row)" icon="el-icon-s-custom" style="float: right"></el-link>-->
<!--           </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--      </template>-->
      <el-table-column
          v-for="(item) in userColumns"
          :key="item.value"
          :prop="item.value"
          :label="item.title"
          header-align="center"
          align="center"
          :width="item.width"
          :slot="item.value"
          sortable>
        <template slot-scope="{row,column}">
          <template v-if="column.property==='title'">
            <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
              <el-link type="primary" style="font-size: 12px" @click="toDetail(row)" title="仅看我权限范围内的客户">
                <el-tag size="small" v-if="row.scope_all==='Y'" effect="plain" plain type="warning"
                        style="margin-right: 5px;" title="重点客户关联的全部客户">全
                </el-tag>
                {{ row.title || '' }}
              </el-link>
              <el-link @click="showRelDialog(row)" icon="el-icon-s-custom" style="float: right"></el-link>
            </div>
          </template>
          <template v-else-if="column.property==='finish_rate'">
            <el-link @click="handleInfoTable(row,column)">{{
                gFunc.numberFormat(row[column.property], 2) || 0
              }}%
            </el-link>
          </template>
          <template v-else>
            <el-link @click="handleInfoTable(row,column)">{{
                gFunc.numberFormat(row[column.property], 2) || 0
              }}
            </el-link>
          </template>
        </template>
      </el-table-column>

    </MlPageTable>

    <!--    <key-account-modal :formStore.sync="formStore" :type="dialogType"-->
    <!--                       @success="successEdit" ref="keyAccountModal" :visible.sync="dialogStore"></key-account-modal>-->

    <info-detail-modal @refresh="handleRefresh('month')" :visible.sync="detailModal"
                       ref="refInfoDetailModal" :search-condition="searchCondition"
                       v-if="searchCondition.id" :is-sale="true"></info-detail-modal>
    <!--    -->
    <dialog-scope-customer ref="refDialogScopeCustomer"></dialog-scope-customer>

  </div>
</template>

<script>
import {deleteProfileCustomer, getProfileCustomerListForSale, RefreshProfileCustomer} from "@/api/profileCustomer";
import MlPageTable from "@/components/MSettingColumn/MlPageTable.vue";
// import KeyAccountModal from "@/views/custom/components/customer/key-account-modal.vue";
import InfoDetailModal from "@/views/custom/components/customer/info-detail-modal.vue";
import {gFunc} from "@/globalFunc";
import DialogScopeCustomer from "@/views/custom/components/customer/sale/DialogScopeCustomer";

const ConfigPage = {
  // layout: 'total, sizes, prev, pager, next, jumper',
  total: 0,
  page_size: 20,
  current_page: 1,
}
export default {
  name: "profileCustomerSale",
  components: {DialogScopeCustomer, InfoDetailModal, MlPageTable},
  data() {
    return {
      configPage: ConfigPage,
      loading: false,
      dialogStore: false,
      dialogType: 'add',
      queryParams: {title: null, year: null, sale_id: null},
      tableData: [],
      userColumns: [],
      prefixColumns: [{
        "hide": false,
        "title": "重点名称",
        "value": "title",
        "field": "title",
        "width": 260,
        "header_align": "center",
        "align": "center",
        "slot": true,
        "fixed": false,
        "sortable": false,
        "editable": false
      }, {
        "hide": false,
        "title": "年度目标",
        "value": "amount",
        "field": "amount",
        "width": 150,
        "header_align": "center",
        "align": "center",
        "slot": true,
        "fixed": false,
        "sortable": false,
        "editable": false
      }],
      suffixColumns: [{
        "hide": false,
        "title": "汇总",
        "value": "total_money",
        "field": "total_money",
        "width": 100,
        "header_align": "center",
        "align": "center",
        "slot": true,
        "fixed": false,
        "sortable": false,
        "editable": false
      }, {
        "hide": false,
        "title": "完成进度",
        "value": "finish_rate",
        "field": "finish_rate",
        "width": 100,
        "header_align": "center",
        "align": "center",
        "slot": true,
        "fixed": false,
        "sortable": false,
        "editable": false
      }],
      tableName: 'profileCustomer',
      formStore: {
        title: null,
        customer_id: null
      },
      isEdit: false,
      updateDate: null,
      detailModal: false,
      searchCondition: {}
    }
  },
  computed: {
    user() {
      return this.$store.getters.getUser
    },
    gFunc() {
      return gFunc
    },
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  created() {
    this.defaultYear()
    this.setColumns()
  },
  mounted() {
    setTimeout(() => {
      this.handleRefresh('year', true)
      // setTimeout(() => {
      //   // this.queryParams.sale_id = this.user.id
      //   this.handleSearch()
      // }, 100)
    },100)
  },
  methods: {
    setColumns() {
      let data = []
      for (let i = 1; i <= 12; i++) {
        let formattedNumber = i < 10 ? '0' + i : i.toString();
        let init = {
          "hide": false,
          "title": `${formattedNumber} 月`,
          "value": `month_${formattedNumber}`,
          "field": `month_${formattedNumber}`,
          "width": 'auto',
          "header_align": "center",
          "align": "center",
          "slot": true,
          "fixed": false,
          "sortable": false,
          "editable": false
        }
        data.push(init)
      }
      this.userColumns = [...this.prefixColumns, ...data, ...this.suffixColumns]
      this.$forceUpdate()
    },
    handleUpdate(row) {
      this.formStore = {...row}
      this.dialogStore = true;
    },
    handleAppend() {
      this.formStore = {}
      this.dialogStore = true
    },
    handleDelete(obj) {
      this.showModal({
        h: this,
        text: `确认删除【${obj.title}】吗？`,
        confirmText: "",
        cancelText: "",
        confirm: async () => {
          this.loading = true
          const response = await deleteProfileCustomer({id: obj.id})
          if (!response.success) {
            this.showToast({h: this, icon: "el-icon-error", text: response.message, duration: 3000});
            return;
          }
          this.showToast({h: this, icon: "el-icon-success", text: '操作成功', duration: 2000});
          await this.getTableData()
          this.loading = false
        }
      });

    },
    handleSearch() {
      // this.queryParams.sale_id = this.user.id
      this.configPage.current_page = 1
      this.getTableData()
    },
    getParams() {
      const params = this.handleSearchCondition()
      Object.assign(params, {
        page_size: this.configPage.page_size,
        current_page: this.configPage.current_page
      })

      return params
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.queryParams).forEach((key) => {
        if (this.queryParams[key]) {
          condition[key] = this.queryParams[key]
        }
      })
      //销售页面，销售ID必传
      condition['sale_id'] = this.user.id
      return condition
    },
    async getTableData() {
      this.loading = true
      //销售的重点客户列表：区别是 每月的金额获取数据范围不同
      const {data} = await getProfileCustomerListForSale(this.getParams())
      this.tableData = data.list || []
      this.configPage = data.pages
      this.configPage.total = data.pages.total || 0
      this.updateDate = data.updateAt || ''
      setTimeout(() => {
        this.loading = false
      }, 200)
    },
    defaultYear() {
      let date = new Date();
      this.queryParams.year = date.getFullYear() + ''
    },
    async successEdit() {
      await this.getTableData()
      this.formStore = {}
      this.dialogStore = false
    },
    async handleRefresh(type, pre_init = false) {
      let queryParams = {}
      switch (type) {
        case 'year':
          queryParams = {
            year: this.queryParams.year,
            sale_id: this.user.id,
            pre_init: pre_init ? 1 : 0,
          }
          break;
        case 'month':
          queryParams = {
            year: this.queryParams.year,
            month: this.searchCondition.month,
            sale_id: this.user.id,
            id: this.searchCondition.id,
            pre_init: pre_init ? 1 : 0,
          }
      }

      const {data} = await RefreshProfileCustomer(queryParams)
      if (data) {
        this.$message.success(data.msg)
        if (type === 'year') {
          // await this.$refs.infoDetailModal.getList()
          setTimeout(async () => {
            await this.getTableData()
          }, 1000)

        }

        if (data.updateAt !== undefined && data.updateAt !== null && data.updateAt !== '') {
          this.updateDate = data.updateAt
        }

      }
    },
    handleInfoTable(row, column) {
      let month = column.property.replace('month_', '')
      if (Number(month)) {
        this.searchCondition = {
          title: row.title,
          month: month,
          id: row.key_customer_id,
          year_month: `${this.queryParams.year}-${month}`
        }
        this.detailModal = true
        this.$nextTick(() => {
          if (this.$refs['refInfoDetailModal'])
            this.$refs['refInfoDetailModal'].init(this.searchCondition)
        })
      }
    },

    showRelDialog(row) {
      // alert(`查看【${row.title}】关联客户`)
      this.$refs['refDialogScopeCustomer'].show(row)
    },
    toDetail(row) {
      const {href} = this.$router.resolve({
        name: `scopeCustomerDetail`,
        query: {
          customerName: row.title,
          year: this.queryParams.year,
          keyCustomerId: row.id
        }
      });
      window.open(href, "_blank");
    },
  }
}
</script>

<style lang="scss">
.customer-container {
  padding: 10px !important;

  .head {
    margin: 10px 0;
  }

  .customer {
    display: inline-block;
    margin: 10px;

    .el-select {
      width: 300px !important;
    }
  }

  .el-pagination {
    position: absolute;
    bottom: 0 !important;
    right: 0 !important;
  }

  .tip-time {

    > * {
      color: #8a8e99;
      font-size: 12px;
      margin-right: 10px;
      float: right;
      line-height: 48px;
    }

  }

}
</style>
